import { render, staticRenderFns } from "./MarketProductTableVariantCategory.vue?vue&type=template&id=295ef951&"
import script from "./MarketProductTableVariantCategory.vue?vue&type=script&lang=js&"
export * from "./MarketProductTableVariantCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports